import { makeStyles } from 'tss-react/mui';

export const ErrorListStyles = makeStyles()({
  noMargin: {
    margin: 0,
  },
});
